/**
 * TanStack Query hooks for `igaming-brand-overrides`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingBrandOverridesQueryKeys,
	type CreateIgamingBrandOverridesBody,
	type ListIgamingBrandOverridesResponse,
	type IgamingBrandOverridesRow,
} from "./api";

export function useIgamingBrandOverridesList(): UseQueryResult<ListIgamingBrandOverridesResponse, Error> {
	return useQuery({
		queryKey: igamingBrandOverridesQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingBrandOverridesCreate(): UseMutationResult<IgamingBrandOverridesRow, Error, CreateIgamingBrandOverridesBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingBrandOverridesQueryKeys.all });
		},
	});
}

export function useIgamingBrandOverridesDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingBrandOverridesQueryKeys.all });
		},
	});
}
